import { publicOperationMiddleware } from '../../../permissions/middlewares/publicOperationMiddleware.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { Person } from '../../../users/entities/person.js';
import { resolveGetUserByTrackerToken } from '../server/resolveGetUserByTrackerToken.js';

export const getUserByTrackerToken = registerQuery({
  operationName: 'getUserByTrackerToken',
  middlewares: [publicOperationMiddleware('Durch signiertes SUS_REGISTRATION-Token geschuetzt')],
  type: () => [Person],
  params: [{ type: () => [String], name: 'token' }],
  resolve: resolveGetUserByTrackerToken,
});
